import { render, staticRenderFns } from "./Markets.vue?vue&type=template&id=31d585ac&scoped=true&"
import script from "./Markets.vue?vue&type=script&lang=js&"
export * from "./Markets.vue?vue&type=script&lang=js&"
import style0 from "./Markets.vue?vue&type=style&index=0&id=31d585ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d585ac",
  null
  
)

export default component.exports